import moment from 'moment-timezone';

import {
  BOOKING_MANAGEMENT_PROCESS_INIT,
  HOTEL_REVIEW_PROCESS_REQUEST,
  HOTEL_REVIEW_PROCESS_SUCCESS,
  HOTEL_REVIEW_PROCESS_FAILURE,
  // modal behavior
  CHANGE_CHECKIN_DATE_REQUEST,
  CHANGE_CHECKIN_DATE_SUCCESS,
  CHANGE_CHECKIN_DATE_FAILURE,
  CANCEL_TICKET_REQUEST,
  CANCEL_TICKET_SUCCESS,
  CANCEL_TICKET_FAILURE,
  CHANGE_BOOKING_STATUS,
  CHANGE_CHECKIN_DATE_REMOVE_ERRORS,
  // payment proccess
  CHANGING_CHECKING_DATE_INIT,
  CHANGING_CHECKING_DATE_SUCCESS,
  CHANGING_CHECKING_DATE_FAILURE,
  CHANGING_CHECKING_DATE_DEFAULT,
  MODAL_CLOSE,
  REHYDRATE_USER_BOOKING,
} from '../types';

const initialState = {
  status: 'initial',
  error: null,
  hotel: null,
  changeCheckingDate: {
    status: 'initial',
    isPaying: false,
    diff: null,
    tax: null,
    type: null,
    error: null,
    newDate: null,
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case REHYDRATE_USER_BOOKING:
      return {
        ...action.payload,
      };
    case BOOKING_MANAGEMENT_PROCESS_INIT:
      return {
        ...state,
        status: 'start',
        hotel: action.payload,
      };
    case CHANGE_BOOKING_STATUS:
      return {
        ...state,
        status: 'start',
        hotel: {
          ...state.hotel,
          status: action.payload,
        },
      };
    case HOTEL_REVIEW_PROCESS_REQUEST:
    case CHANGE_CHECKIN_DATE_REQUEST:
    case CANCEL_TICKET_REQUEST:
      return {
        ...state,
        status: 'fetching',
      };
    case HOTEL_REVIEW_PROCESS_SUCCESS:
      return {
        ...state,
        status: 'success',
      };
    case CHANGE_CHECKIN_DATE_REMOVE_ERRORS:
      return {
        ...state,
        error: null,
      }
    case CHANGE_CHECKIN_DATE_SUCCESS:
      return {
        ...state,
        status: 'success',
        hotel: {
            ...state.hotel,
            checkinDate: action.payload,
            expiration: moment(action.payload).add(1, 'day'),
            expirationDate: moment(action.payload).add(1, 'day'),
          }
      };
    case CANCEL_TICKET_SUCCESS:
      return {
        ...state,
        status: 'success',
        hotel: {
            ...state.hotel,
            status: 3,
          }
        };
    case HOTEL_REVIEW_PROCESS_FAILURE:
    case CHANGE_CHECKIN_DATE_FAILURE:
    case CANCEL_TICKET_FAILURE:
      return {
        ...state,
        status: 'failure',
        error: action.payload,
      };
    case CHANGING_CHECKING_DATE_INIT:
      return {
        ...state,
        changeCheckingDate: {
          ...state.changeCheckingDate,
          status: 'start',
          isPaying: true,
          ...action.payload,
        }
      }
    case CHANGING_CHECKING_DATE_SUCCESS:
      return {
        ...state,
        changeCheckingDate: {
          status: 'success',
          isPaying: false,
          diff: null,
          tax: null,
          type: null,
          error: null,
          ...action.payload,
        }
      }
    case CHANGING_CHECKING_DATE_FAILURE:
      return {
        ...state,
        changeCheckingDate: {
          status: 'failure',
          isPaying: false,
          diff: null,
          tax: null,
          type: null,
          error: action.payload,
        }
      }
    case MODAL_CLOSE:
    case CHANGING_CHECKING_DATE_DEFAULT:
      return {
        ...state,
        status: 'initial',
        error: null,
        changeCheckingDate: {
          status: 'initial',
          isPaying: false,
          diff: null,
          tax: null,
          type: null,
          error: null,
          newDate: null,
        }
      }
    default:
      return state;
  }
}
